import React from 'react';
import useIsMobile from '@/hooks/useIsMobile';
import CustomerInfoEdit from 'components/customer/CustomerInfoEdit';
import CustomerInfo from 'components/customer/InfoModal2';
import CustomerPickerDesktop from './desktop';
import CustomerPickerMobile from './mobile';
import useCustomerPicker from './useCustomerPicker';

const CustomerPicker = (props) => {
  const isMobile = useIsMobile(992);
  const viewModel = useCustomerPicker(props);

  return (
    <>
      {isMobile ? <CustomerPickerMobile viewModel={viewModel} /> : <CustomerPickerDesktop viewModel={viewModel} />}
      <CustomerInfoEdit
        open={viewModel.showAddCustomer}
        onClose={() => viewModel.setShowAddCustomer(false)}
        onSave={viewModel.onCustomerSaved}
      />
      <CustomerInfo
        id={viewModel.value}
        open={viewModel.showCustomerInfo}
        onClose={() => viewModel.setShowCustomerInfo(false)}
      />
    </>
  );
};

export default CustomerPicker;